<!--
  Outlier badge (§4.1). Warning icon + "Outlier" text, never colour-only.
  Designed to sit inline after the status badge. The icon is decorative
  (aria-hidden) — the label and aria-label carry the meaning.

  No role="status": AC4 only mandates the aria-label, not a live region. The
  badge is a static label, and the companion status badge already carries
  role="status" (AC3) — a second aria-live region would cause redundant
  screen-reader announcements when many rows render in a DxDataGrid (Epic 3/4).
-->
<span class="pf-outlier-badge" [attr.aria-label]="ariaLabel">
  <svg class="pf-outlier-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12 2 1 21h22L12 2zm0 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-1-7h2v5h-2V9z" />
  </svg>
  <span>Outlier</span>
</span>
